export const PROD_LOGIN_URL = 'https://revolab.global/lis/login/';
export const STAGING_LOGIN_URL = 'https://staging.revolab.tech/lis/login/';
export const DEV_LOGIN_URL = 'https://dev.revolab.tech/lis/login/';
export const LOCAL_LOGIN_URL = 'http://localhost/lis/login/';
